import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const TestimonialSection = () => {
  const [activeTestimonial, setActiveTestimonial] = useState(0);

  const testimonials = [
    {
      id: 1,
      name: "Rajesh Kumar",
      position: "CEO, TechVision Solutions",
      company: "TechVision Solutions",
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1a341e72a-1763295403609.png",
      imageAlt: "Professional headshot of Indian businessman Rajesh Kumar in navy blue suit with confident smile in modern office setting",
      rating: 5,
      text: "InChi Solutions Pvt Ltd transformed our HR operations completely. Their comprehensive approach to talent acquisition and management helped us scale from 50 to 200 employees seamlessly. The team\'s expertise in compliance and payroll management saved us countless hours and resources.",
      service: "HR Solutions",
      projectValue: "₹45,00,000",
      duration: "18 months"
    },
    {
      id: 2,
      name: "Priya Sharma",
      position: "Operations Director, Global Exports Ltd",
      company: "Global Exports Ltd",
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_150f92757-1763295812976.png",
      imageAlt: "Professional portrait of Indian businesswoman Priya Sharma in formal burgundy blazer with warm smile in corporate office environment",
      rating: 5,
      text: "Working with InChi's Global Trade Network opened doors to markets we never thought possible. Their supplier connections and trade facilitation expertise helped us expand to 12 new countries. The ROI has been exceptional, and their ongoing support is invaluable.",
      service: "Global Trade",
      projectValue: "₹1,20,00,000",
      duration: "24 months"
    },
    {
      id: 3,
      name: "Amit Patel",
      position: "CTO, InnovateTech Systems",
      company: "InnovateTech Systems",
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1cb468779-1763295443265.png",
      imageAlt: "Professional photograph of Indian technology executive Amit Patel in charcoal gray suit with glasses in modern tech office backdrop",
      rating: 5,
      text: "The engineering services provided by InChi Solutions Pvt Ltd exceeded all expectations. Their team integrated seamlessly with ours, bringing specialized expertise that accelerated our product development by 40%. The quality of deliverables and attention to detail is outstanding.",
      service: "Engineering Services",
      projectValue: "₹85,00,000",
      duration: "12 months"
    }];


  const nextTestimonial = () => {
    setActiveTestimonial((prev) => (prev + 1) % testimonials?.length);
  };

  const prevTestimonial = () => {
    setActiveTestimonial((prev) => (prev - 1 + testimonials?.length) % testimonials?.length);
  };

  const current = testimonials?.[activeTestimonial];

  return (
    <section className="py-12 md:py-16 lg:py-20 bg-gradient-to-br from-primary/5 to-secondary/5">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center mb-8 md:mb-12">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground mb-3 md:mb-4">
            Client Success Stories
          </h2>
          <p className="text-sm md:text-base lg:text-lg text-muted-foreground max-w-3xl mx-auto">
            Hear from our 678+ satisfied clients about their transformation journey with InChi Solutions Pvt Ltd
          </p>
        </div>

        <div className="bg-card rounded-xl shadow-xl overflow-hidden">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-0">
            <div className="p-6 md:p-8 lg:p-12 flex flex-col justify-center">
              <div className="flex items-center gap-1 mb-4 md:mb-6">
                {[...Array(current?.rating)]?.map((_, i) =>
                  <Icon key={i} name="Star" size={20} className="text-warning fill-warning" />
                )}
              </div>

              <blockquote className="text-base md:text-lg lg:text-xl text-foreground mb-6 md:mb-8 leading-relaxed">
                "{current?.text}"
              </blockquote>

              <div className="flex items-center gap-4 mb-6 md:mb-8">
                <div className="w-14 h-14 md:w-16 md:h-16 rounded-full overflow-hidden flex-shrink-0">
                  <Image
                    src={current?.image}
                    alt={current?.imageAlt}
                    className="w-full h-full object-cover" />

                </div>
                <div className="flex-grow min-w-0">
                  <div className="font-bold text-foreground text-base md:text-lg line-clamp-1">
                    {current?.name}
                  </div>
                  <div className="text-xs md:text-sm text-muted-foreground line-clamp-1">
                    {current?.position}
                  </div>
                  <div className="text-xs md:text-sm text-primary font-semibold line-clamp-1">
                    {current?.company}
                  </div>
                </div>
              </div>

              <div className="grid grid-cols-3 gap-3 md:gap-4 mb-6 md:mb-8">
                <div className="bg-muted rounded-lg p-3 md:p-4 text-center">
                  <div className="text-xs md:text-sm text-muted-foreground mb-1">Service</div>
                  <div className="text-xs md:text-sm font-semibold text-foreground line-clamp-1">
                    {current?.service}
                  </div>
                </div>
                <div className="bg-muted rounded-lg p-3 md:p-4 text-center">
                  <div className="text-xs md:text-sm text-muted-foreground mb-1">Value</div>
                  <div className="text-xs md:text-sm font-semibold text-foreground whitespace-nowrap">
                    {current?.projectValue}
                  </div>
                </div>
                <div className="bg-muted rounded-lg p-3 md:p-4 text-center">
                  <div className="text-xs md:text-sm text-muted-foreground mb-1">Duration</div>
                  <div className="text-xs md:text-sm font-semibold text-foreground whitespace-nowrap">
                    {current?.duration}
                  </div>
                </div>
              </div>

              <div className="flex items-center justify-between">
                <div className="flex gap-2">
                  {testimonials?.map((_, index) =>
                    <button
                      key={index}
                      onClick={() => setActiveTestimonial(index)}
                      className={`w-2 h-2 rounded-full transition-all duration-200 ${index === activeTestimonial ?
                        'bg-primary w-8' : 'bg-muted-foreground/30'}`
                      }
                      aria-label={`Go to testimonial ${index + 1}`} />

                  )}
                </div>
                <div className="flex gap-2">
                  <button
                    onClick={prevTestimonial}
                    className="w-10 h-10 rounded-lg bg-muted hover:bg-muted/80 flex items-center justify-center transition-colors"
                    aria-label="Previous testimonial">

                    <Icon name="ChevronLeft" size={20} />
                  </button>
                  <button
                    onClick={nextTestimonial}
                    className="w-10 h-10 rounded-lg bg-primary hover:bg-primary/90 text-white flex items-center justify-center transition-colors"
                    aria-label="Next testimonial">

                    <Icon name="ChevronRight" size={20} />
                  </button>
                </div>
              </div>
            </div>

            <div className="relative h-64 lg:h-auto min-h-[400px] bg-gradient-to-br from-primary to-secondary">
              <div className="absolute inset-0 flex items-center justify-center p-6 md:p-8">
                <div className="text-center text-white space-y-4 md:space-y-6">
                  <Icon name="Quote" size={64} className="mx-auto opacity-20" />
                  <div className="text-4xl md:text-5xl lg:text-6xl font-bold">678+</div>
                  <div className="text-lg md:text-xl lg:text-2xl font-semibold">
                    Satisfied Clients
                  </div>
                  <div className="text-sm md:text-base opacity-90">
                    Across 25+ countries worldwide
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>);

};

export default TestimonialSection;